import PropTypes from 'prop-types';
import React from 'react';

import { AppConfig } from '../core-bundle/config/app-config';

import Router from '@module/router';
import Spinner from '@component/spinner';
import Icon from '@component/icon';
import Store from '@app/store';
import { FLAMINGO, DODGER_BLUE } from '@constant/colors';

export default class Logo extends React.Component {
  static propTypes = {
    route: PropTypes.object,
    progressPercentage: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);

    this.closePanel = this.closePanel.bind(this);
  }

  // Route to a different page to close the panel
  closePanel() {
    const { channel, transfer, session } = Store.getState();

    if (this.props.route.type === 'transfer' && channel.name) {
      // Redirect to root domain if on a channel with panel closed
      document.location =
        window.location.protocol +
        '//' +
        session.domain +
        (window.location.port ? ':' + window.location.port : '');
    } else if (transfer.id && this.props.route.params.secret) {
      // Go to the home page if the user is on a root domain and a transfer is opened.
      Router.navigateTo('/');
    } else {
      // Close panel, open last transfer route.
      Router.navigateTo(Router.getLastRoute('transfer', '/'));
    }
  }

  render() {
    const { transfer, layout } = Store.getState();

    const spinnerClassNames = ['logo'];
    let rotate = false;
    let percentage = 0;

    // If we are on a page (full-width) (or half page on a small screen) and the transfer is in progress
    // we will display the spinner with percentage and rotation.
    // We show an icon if the transfer is completed or aborted.
    if (
      this.props.route.type === 'page' ||
      (this.props.route.type === 'plus' &&
        window.innerWidth <= AppConfig.panel.full_panel_breakpoint)
    ) {
      if (transfer.state === 'started' || transfer.state === 'paused') {
        spinnerClassNames.push('logo--transferring');
        percentage = this.props.progressPercentage;
        rotate = true;
      } else if (transfer.state === 'finished') {
        spinnerClassNames.push('logo--finished');
      } else if (transfer.state === 'aborted') {
        spinnerClassNames.push('logo--aborted');
      }
    }

    if (layout.hidden === true) {
      spinnerClassNames.push('logo--html5-fullscreen');
    }

    // Spinner is always full when the state is finished or aborted. Yes, also when the panel is closed due to the circle-filling-up effect
    if (transfer.state === 'finished' || transfer.state === 'aborted') {
      percentage = 99.99;
    }

    // We do not unmount the error/valid-icons since we want to preserve the css-transform-animations. Using Velocity is a bit of a overkill imho.
    return (
      <Spinner
        onClick={this.closePanel}
        className={spinnerClassNames.join(' ')}
        rotate={rotate}
        percentage={percentage}
        hideText
        circumference={44}
        stroke={3}
        foreground={transfer.state === 'aborted' ? FLAMINGO : DODGER_BLUE}
      >
        <Icon type="Logo" shadow={true} className="spinner__logo" width={44} />
        <Icon
          type="TransferError"
          className="spinner__aborted"
          color={FLAMINGO}
          circle={false}
        />
        <Icon type="Valid" className="spinner__finished" color={DODGER_BLUE} />
      </Spinner>
    );
  }
}
